// import "weixin-js-sdk";
import * as helper from "./helper";
import * as GPS from "./gps_convert";

export default class Wechat {
  constructor(config) {
    this.$options = config;
  }

  ready() {
    console.log("is wechat ready");
    return new Promise(async resolve => {
      if (this.isReady) return resolve(true);
      const sdkDomain = document.getElementById("wxJSSDKDomain").value;
      const loadUrl = `${sdkDomain}/open/js/jweixin-1.6.0.js`;

      const loaded = await helper.loadModule(loadUrl);
      if (!loaded) return resolve(false);

      window.wx.config(this.$options);

      window.wx.ready(() => {
        console.log("wechat ready");
        this.isReady = true;
        resolve(true);
      });
    });
  }

  async getLocation() {
    const result = await helper.promisify(window.wx.getLocation)({
      type: "gcj02"
    });
    if (result.success) {
      result.result = result.data;
      const point = GPS.gcj02_To_Bd09(
        result.data.longitude,
        result.data.latitude
      );
      result.data = {
        latitude: point.lat,
        longitude: point.lng
      };
    }
    return result;
  }

  shareMessage(data) {
    return helper.promisify(window.wx.updateAppMessageShareData)(data);
  }

  shareTimeline(data) {
    return helper.promisify(window.wx.onMenuShareTimeline)(data);
  }

  previewImage(data) {
    return helper.promisify(window.wx.previewImage)(data);
  }

  async scanCode({ needResult }) {
    console.log("wechat scan code");
    const result = await helper.promisify(window.wx.scanQRCode)({
      needResult: +needResult,
      scanType: ["qrCode", "barCode"]
    });
    if (result.success) {
      console.log("result ", result.data);
      result.result = result.data;
      result.data = result.data.resultStr;
    }
    return result;
  }
}
